<template>
  <div class="goodsshelves">
    <div style="padding: 15px">
      <waterfall :col="2" :gutterWidth="10" :data="data">
        <template>
          <div
            @click="toserver(item)"
            class="box"
            v-for="(item, index) in data"
            :key="index"
          >
            <div class="imgbox">
              <img :src="item.icon || item.webImage" />
              <p v-if="item.subtitle" class="imgname">{{ item.subtitle }}</p>
            </div>
            <p class="name">{{ item.serviceAlias }}</p>
          </div>
        </template>
      </waterfall>
    </div>
    <nodata :nodata="nodata" :msg="'暂无数据~'"></nodata>
  </div>
</template>

<script>
// import imgbaseurl from "@/util/imgconfig";
import { getgoodsshelvesServer } from "@/api/api";
var _this;
export default {
  data() {
    return {
      // imgbaseurl: imgbaseurl.imgServerUrl,
      nodata: false,
      type: "",
      data: []
    };
  },
  computed: {
    itemWidth() {
      return 138 * 0.5 * (document.documentElement.clientWidth / 375);
    },
    gutterWidth() {
      return 9 * 0.5 * (document.documentElement.clientWidth / 375);
    }
  },
  methods: {
    toserver(item) {
      window.location.href = item.actionUrl;
    },
    getgoodsshelvesServer() {
      getgoodsshelvesServer(this.type).then(res => {
        console.log(res);
        // _this.data = res.data[0].children;
        if (res.code == 200 && res.data.length > 0) {
          _this.nodata = false;
          _this.data = res.data[0].children;
        } else {
          _this.data = [];
          _this.nodata = true;
        }
      });
    }
  },
  mounted() {
    this.getgoodsshelvesServer();
  },
  created() {
    _this = this;
    this.type = this.$route.query.type || "lnyxyp";
    let title = "";
    switch (this.type) {
      case "lnyxyp":
        title = "一乡一品";
        break;
      case "lnlyjd":
        title = "旅游景点";
        break;
      default:
        title = "龙城市民云";
        break;
    }
    if (this.$eshimin) {
      this.$eshimin.setTitle({
        title: title,
        onResponse: function(res) {
          console.log("setTitle res:" + res);
        }
      });
    }
  }
};
</script>

<style lang="less">
.goodsshelves {
  // padding: 15px;
  //   column-count: 2;
  //   column-gap: 10px;
  .vue-waterfall {
    // color: blue;
    div:nth-of-type(2) {
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
    }
    div:last-child {
      display: flex;
      justify-content: flex-end;
      flex-wrap: wrap;
    }
  }
  .box {
    background: #ffffff;
    border-radius: 8px;
    width: 147px;
    padding: 9px;
    margin-bottom: 15px;
    .imgbox {
      width: 147px;
      height: 147px;
      border-radius: 4px;
      position: relative;
      img {
        width: 100%;
        height: 100%;
        border-radius: 4px;
        object-fit: cover;
      }
      .imgname {
        position: absolute;
        bottom: 0;
        left: 0;
        right: 0;
        // width: 100%;
        background: rgba(0, 0, 0, 0.58);
        border-radius: 0px 3px 3px 0px;
        padding: 2px 4px;
        // text-indent: 4px;
        font-size: 12px;
        font-weight: 500;
        color: #ffffff;
        line-height: 17px;
      }
    }
    .name {
      font-size: 14px;
      padding-top: 5px;
      font-weight: 500;
      color: #333333;
      line-height: 20px;
      width: 100%;
    }
  }
}
</style>
